export default "__VITE_ASSET__9c3179f0__"